import { type AlgoliaRecord } from '../../../algolia'

const ALGOLIA_RECORD_STOCK_STATUS_AVAILABLE = 'available'
const ALGOLIA_RECORD_STOCK_STATUS_EMPTY = ''

/*
  We check the statuses coming from Algolia for a specific Record (Product) based on the Algolia values.
  PIM responses have different statuses (most of the times similar) and it is safer to have a separate status validation process for Algolia Records.
 */
export const productSearchAlgoliaAccessorStockStatusIsAvailable = (
  product: AlgoliaRecord,
): boolean => {
  return (
    product.status === ALGOLIA_RECORD_STOCK_STATUS_AVAILABLE ||
    product.status === ALGOLIA_RECORD_STOCK_STATUS_EMPTY
  )
}
